import PropTypes from 'prop-types';
import { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import api from 'atg/api/API';
import { ALL } from 'atg/constants/CouponCriteria';
import { clearCoupons, createCoupon } from 'atg/redux/actions';
import { coupons } from 'atg/redux/selectors';
import CloseButton from 'shared/components/button/CloseButton';
import ErrorInfo from 'shared/components/ErrorInfo';
import * as Text from 'shared/utils/Text';
import { toAbsoluteUrl } from 'shared/utils/urls';

import CouponsForm from './coupons/CouponsForm';
import CouponsResult from './coupons/CouponsResult';

const mapStateToProps = state => ({
  couponUrls: coupons.getUrls(state),
  errors: coupons.getErrors(state),
  isLoading: coupons.isLoading(state),
  betResultStarted: api.resultInformation.hasResult(),
  betResultComplete: api.resultInformation.isResultComplete(),
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ createCoupon, clearCoupons }, dispatch);

const CouponsDialog = props => {
  const {
    couponUrls,
    errors,
    isLoading,
    betResultStarted,
    betResultComplete,
    createCoupon,
    clearCoupons,
    closeHandler,
  } = props;

  const [selectedCriteria, setSelectedCriteria] = useState(ALL);
  const [showResult, setShowResult] = useState(false);

  // Clear redux state on unmount
  useEffect(
    () => () => {
      clearCoupons();
    },
    [clearCoupons],
  );

  useEffect(() => {
    if (errors[selectedCriteria] != null) {
      setShowResult(false);
    }
  }, [errors, selectedCriteria]);

  const onChangeCriteria = useCallback(criteria => {
    setSelectedCriteria(criteria);
  }, []);

  const onCreateClick = useCallback(() => {
    setShowResult(true);
    createCoupon(selectedCriteria);
  }, [createCoupon, selectedCriteria]);

  const onResetSelectedCriteria = useCallback(() => {
    setShowResult(false);
  }, []);

  let downloadUrl = couponUrls[selectedCriteria];
  if (downloadUrl != null) {
    downloadUrl = toAbsoluteUrl(downloadUrl);
  }

  return (
    <>
      <h1 className="dialog-title">{Text.get('dialog-coupons-title')}</h1>
      <CloseButton onClick={closeHandler} />
      <hr />
      {errors[selectedCriteria] != null && (
        <ErrorInfo error={errors[selectedCriteria]} />
      )}
      {(isLoading || !showResult) && (
        <CouponsForm
          onCreateClick={onCreateClick}
          onChangeCriteria={onChangeCriteria}
          criteria={selectedCriteria}
          isLoading={isLoading}
          betResultStarted={betResultStarted}
          betResultComplete={betResultComplete}
        />
      )}
      {!isLoading && showResult && downloadUrl && (
        <CouponsResult
          criteria={selectedCriteria}
          downloadUrl={downloadUrl}
          onBackClick={onResetSelectedCriteria}
          betResultStarted={betResultStarted}
          betResultComplete={betResultComplete}
        />
      )}
    </>
  );
};

CouponsDialog.propTypes = {
  closeHandler: PropTypes.func.isRequired,
  createCoupon: PropTypes.func.isRequired,
  clearCoupons: PropTypes.func.isRequired,
  couponUrls: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  betResultStarted: PropTypes.bool.isRequired,
  betResultComplete: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(CouponsDialog);
